import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronDown20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.46967 8.03028L4.53033 6.96962L10 12.4393L15.4697 6.96962L16.5303 8.03028L10 14.5606L3.46967 8.03028Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronDown20.displayName = 'ChevronDown20';
export default ChevronDown20;
